import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './Stepper.scss';

const Stepper = ({ listSteps }) => {
  const currentStep = useSelector((state) => state?.currentStep?.initialState);

  const [filteredSteps, setFilteredSteps] = useState([]);

  const getWizardList = () => {
    const listOfSteps = listSteps?.map((el, index) => {
      const temp = el;
      temp.stepValues = index;
      return temp;
    });

    return listOfSteps;
  };

  useEffect(() => {
    /* eslint-disable */
    setFilteredSteps(getWizardList());
  }, [currentStep]);

  return (
    <div className="stepper">
      {filteredSteps?.map((el) => {
        return (
          <div
            key={el.id}
            className={`step-value ${
              el.stepValues < currentStep ? 'complete' : ''
            } ${
              Number(el.stepValues) === Number(currentStep) ? 'current' : ''
            }`}
          >
            {el.stepperLabel}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
